import React from 'react'
import FilterMatchesScreen from './FilterMatchesScreen';
import {useSelector} from 'react-redux';
function MyMatches() {
    const {user} = useSelector(state => state.user)

    return (
        <FilterMatchesScreen user={user} matches={user.newMatches} title="Members who match most of your Preferences" />
    )
}

export default MyMatches